import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import StoryProgressOverall from '../Crosspage/StoryProgressOverall';
import { useTranslation } from 'react-i18next';

export default function StoryWidget(props) {

    const {i18n} = useTranslation()

    console.log(props);

    const foundBestPath = props.progress ? props.progress.foundBestPath : false;
    const paths_done = props.progress ? props.progress.finishedPaths.length : 0;
    const n_choices = props.n_choices;

    return(
        <Paper key={props.story.id} sx={{p: 1, ml: {xs: 0, sm: 1}, mr: {xs: 0, sm: 1}, mb: 1, mt: 1, display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center"}}>
            <Box sx={{display: "flex", flexDirection: "column", width: "100%"}}>
                <Typography>{props.story.title[i18n.language]}</Typography>
                <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-evenly", m: 1}}>
                    <img src={props.charImg} height={150}/>
                    <StoryProgressOverall foundBestPath={foundBestPath} n_done={paths_done} n_paths={n_choices}/>
                </Box>
            </Box>
        </Paper>
    )
}